import { Link, useLocation } from "react-router-dom";

const addItems = [
  { label: "Add Customer", to: "/add-customer", icon: "➕" },
  { label: "Create New Order", to: "/create-order", icon: "➕" },
  { label: "Add New Arrivals", to: "/latest-collections", icon: "➕" },
];

const viewItems = [
  { label: "View All Customers", to: "/customers", icon: "👤" },
  { label: "View All Orders", to: "/view-orders", icon: "📦" },
  { label: "Order Images", to: "/mobile-orders", icon: "📱" },
  { label: "View New Arrivals", to: "/collections", icon: "👕" },
];

const otherItems = [
  { label: "Home", to: "/", icon: "🏠" },
  // Add more unique/other links here if needed
];

export default function Sidebar({ open, onClose }) {
  const location = useLocation();
  return (
    <>
      {/* Overlay for mobile */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-30 z-40 transition-opacity duration-300 md:hidden ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={onClose}
      />
      <aside
        className={`
          fixed z-50 top-0 left-0 h-full w-64 bg-gray-900 text-white flex flex-col py-6 px-4
          transform transition-transform duration-300 ease-in-out
          ${open ? "translate-x-0" : "-translate-x-full"}
          md:static md:translate-x-0 md:w-56 md:block
        `}
        style={{ touchAction: 'manipulation' }}
      >
        {/* Close button for mobile */}
        <button
          className="md:hidden mb-6 text-3xl self-end px-2 py-1 focus:outline-none"
          onClick={onClose}
          aria-label="Close menu"
        >
          &times;
        </button>
        <div className="text-2xl font-bold mb-8 tracking-wide text-center md:text-left"></div>
        <nav className="flex-1">
          {/* Other/unique links */}
          {otherItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-2 md:gap-3 px-2 py-2 rounded-lg mb-2 transition text-base md:text-sm \
                ${location.pathname === item.to ? "bg-gray-800" : "hover:bg-gray-800"}`}
              onClick={onClose}
            >
              <span className="text-lg md:text-base shrink-0">{item.icon}</span>
              <span className="truncate">{item.label}</span>
            </Link>
          ))}

          {/* Add Items Section */}
          <div className="mt-6 mb-2 text-xs font-semibold uppercase tracking-wider text-gray-400">Add Items</div>
          {addItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-2 md:gap-3 px-2 py-2 rounded-lg mb-2 transition text-base md:text-sm \
                ${location.pathname === item.to ? "bg-gray-800" : "hover:bg-gray-800"}`}
              onClick={onClose}
            >
              <span className="text-lg md:text-base shrink-0">{item.icon}</span>
              <span className="truncate">{item.label}</span>
            </Link>
          ))}

          {/* View Items Section */}
          <div className="mt-6 mb-2 text-xs font-semibold uppercase tracking-wider text-gray-400">View Items</div>
          {viewItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-2 md:gap-3 px-2 py-2 rounded-lg mb-2 transition text-base md:text-sm \
                ${location.pathname === item.to ? "bg-gray-800" : "hover:bg-gray-800"}`}
              onClick={onClose}
            >
              <span className="text-lg md:text-base shrink-0">{item.icon}</span>
              <span className="truncate">{item.label}</span>
            </Link>
          ))}
        </nav>
      </aside>
    </>
  );
}
